import { useCallback } from 'react';
import { useRootStore } from '~/stores/useRootStore';

const useOpenSessionEditTab = (sessionId: string) => {
    const {
        userStore: { currUser }
    } = useRootStore();

    const sessionEditHref = `/app/session/${sessionId}/user/${currUser._id}?origin=builder`;

    const openSessionEditTab = useCallback(
        () => window.open(sessionEditHref, '_blank', 'noopener noreferrer'),
        [sessionEditHref]
    );

    return { openSessionEditTab, sessionEditHref };
};

export default useOpenSessionEditTab;
